import React from 'react';
import { IconProps } from '.';

const SvgEyeOn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2.862 12a16.569 16.569 0 0 0 2.289 2.977C6.789 16.658 9.107 18.25 12 18.25c2.893 0 5.211-1.592 6.849-3.273A16.568 16.568 0 0 0 21.138 12a16.567 16.567 0 0 0-2.289-2.977c-1.638-1.681-3.956-3.273-6.85-3.273-2.892 0-5.21 1.592-6.848 3.273A16.567 16.567 0 0 0 2.86 12ZM22 12l.665.346-.001.003-.003.006-.01.018-.036.067a15.969 15.969 0 0 1-.66 1.072 18.06 18.06 0 0 1-2.031 2.511C18.152 17.842 15.47 19.75 12 19.75c-3.47 0-6.152-1.908-7.924-3.727a18.062 18.062 0 0 1-2.555-3.344 10.614 10.614 0 0 1-.172-.306l-.01-.018-.003-.006-.001-.002L2 12a81.919 81.919 0 0 1-.665-.346l.001-.003.003-.006.01-.018.036-.067a15.944 15.944 0 0 1 .66-1.072 18.062 18.062 0 0 1 2.031-2.511C5.848 6.158 8.53 4.25 12 4.25c3.47 0 6.152 1.908 7.924 3.727a18.06 18.06 0 0 1 2.555 3.344 10.833 10.833 0 0 1 .172.306l.01.018.003.006v.002c.001 0 .002.001-.664.347Zm0 0 .665.346.18-.346-.18-.346L22 12ZM2 12l-.666.346-.18-.346.18-.346L2 12Zm.665.346Zm0-.692Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgEyeOn;
